<template>
  <div class="card">
    <Toast />
    <div class="title">Laporan Stok Barang</div>

    <DataTable
      :value="items"
      :paginator="true"
      class="p-datatable-sm"
      :rows="limit"
      :totalRecords="total"
      :first="first"
      :lazy="true"
      :loading="loading.main"
      :scrollable="true"
      scrollHeight="400px"
      scrollDirection="both"
      @page="onPage"
    >
      <template #header>
        <div class="filter-section p-fluid">
          <div class="p-grid">
            <div class="p-col-12 p-md-3">
              <label for="item-code" class="block mb-1">Kode Item</label>
              <InputText
                id="item-code"
                v-model="filters.item_code"
                placeholder="Cari Kode Item"
                class="w-100"
              />
            </div>
            <div class="p-col-12 p-md-3">
              <label for="item-name" class="block mb-1">Nama Item</label>
              <InputText
                id="item-name"
                v-model="filters.item_name"
                placeholder="Cari Nama Item"
                class="w-100"
              />
            </div>
            <div class="p-col-12 p-md-3">
              <label for="category" class="block mb-1">Kategori</label>
              <InputText
                id="category"
                v-model="filters.category"
                placeholder="Cari Kategori"
                class="w-100"
              />
            </div>
            <div class="p-col-12 p-md-3">
              <label for="supplier" class="block mb-1">Supplier</label>
              <span class="p-input-icon-right w-100" style="display: block">
                <i
                  v-if="loading.suppliers"
                  class="pi pi-spin pi-spinner"
                  style="z-index: 10"
                ></i>
                <AutoComplete
                  id="supplier"
                  v-model="supplier_selected"
                  :suggestions="autoFilteredValue"
                  field="displayName"
                  @complete="searchSupplier($event)"
                  :dropdown="true"
                  placeholder="Cari supplier..."
                  class="w-100"
                >
                  <template #item="slotProps">
                    <div class="warehouse-item">
                      <span class="warehouse-text">{{
                        slotProps.item.displayName
                      }}</span>
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>

          <div class="p-grid p-mt-3">
            <div class="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-end">
              <Button
                label="Cari"
                icon="pi pi-search"
                @click="getListStockItemsWarehouse()"
                :loading="loading.main"
                class="p-mr-2"
              />
              <Button
                label="Reset"
                icon="pi pi-refresh"
                @click="resetFilters()"
                class="p-button-secondary"
                v-tooltip.top="'Reset Filter'"
              />
            </div>
          </div>
        </div>
      </template>

      <template #empty>
        <div class="p-d-flex p-ai-center p-jc-center p-mt-3">
          <span class="p-text-secondary">Data tidak tersedia.</span>
        </div>
      </template>

      <Column
        field="no"
        header="No"
        :sortable="false"
        headerStyle="width: 60px; min-width: 60px; text-align: center"
        bodyStyle="width: 60px; min-width: 60px; text-align: center"
      >
        <template #body="slotProps">
          {{ (currentPage - 1) * rowsPerPage + slotProps.index + 1 }}
        </template>
      </Column>

      <Column
        field="item_code"
        header="Kode Barang"
        headerStyle="width: 120px; min-width: 120px"
        bodyStyle="width: 120px; min-width: 120px"
      >
        <template #body="slotProps">
          {{ slotProps.data.item_code }}
        </template>
      </Column>

      <Column
        field="item_name"
        header="Nama Barang"
        headerStyle="width: 200px; min-width: 200px; max-width: 200px"
        bodyStyle="width: 200px; min-width: 200px; max-width: 200px"
      >
        <template #body="slotProps">
          <span>{{ truncateText(slotProps.data.item_name, 20) }}</span>
        </template>
      </Column>

      <Column
        header="Supplier"
        headerStyle="width: 200px; min-width: 200px; max-width: 200px"
        bodyStyle="width: 200px; min-width: 200px; max-width: 200px"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.sup_code && slotProps.data.sup_name">
            {{
              truncateText(
                `${slotProps.data.sup_code} - ${slotProps.data.sup_name}`,
                20
              )
            }}
          </span>
          <span v-else class="p-text-secondary">-</span>
        </template>
      </Column>

      <Column
        header="Kategori"
        headerStyle="width: 200px; min-width: 200px; max-width: 200px"
        bodyStyle="width: 200px; min-width: 200px; max-width: 200px"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.cat_code && slotProps.data.cat_name">
            {{
              truncateText(
                `${slotProps.data.cat_code} - ${slotProps.data.cat_name}`,
                20
              )
            }}
          </span>
          <span v-else class="p-text-secondary">-</span>
        </template>
      </Column>

      <Column
        header="Stok Terkini"
        headerStyle="width: 100px; min-width: 100px; text-align: right"
        bodyStyle="width: 100px; min-width: 100px; text-align: right"
      >
        <template #body="slotProps">
          <span>{{ slotProps.data.current_stock | number }}</span>
        </template>
      </Column>

      <Column
        header="Stok Pending"
        headerStyle="width: 100px; min-width: 100px; text-align: right"
        bodyStyle="width: 100px; min-width: 100px; text-align: right"
      >
        <template #body="slotProps">
          <span>{{ slotProps.data.pending_stock | number }}</span>
        </template>
      </Column>

      <Column
        header="Total Stock"
        headerStyle="width: 100px; min-width: 100px; text-align: right"
        bodyStyle="width: 100px; min-width: 100px; text-align: right"
      >
        <template #body="slotProps">
          <span>{{ slotProps.data.total_stock | number }}</span>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      filters: {
        item_code: '',
        item_name: '',
        category: ''
      },
      supplier_selected: null,
      autoFilteredValue: [],
      loading: {
        main: false,
        suppliers: false
      },
      items: [],
      limit: 15,
      total: 0,
      first: 0,
      page: 1,
      currentPage: 1,
      rowsPerPage: 15
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getListStockItemsWarehouse()
    this.initDebouncedSearch()
  },
  beforeDestroy() {
    // Cleanup debounced function
    if (this.$_searchSuppliersDebounced) {
      this.$_searchSuppliersDebounced = null
    }
  },
  methods: {
    /**
     * Unified method to fetch stock items with pagination and filters
     * @param {Object} event - Pagination event (optional)
     */
    async getListStockItemsWarehouse(event = null) {
      this.loading.main = true

      // Determine page number
      let page = 1
      if (event) {
        // Pagination event - extract page and update pagination state
        page = event.page + 1
        this.currentPage = page
        this.rowsPerPage = event.rows
        this.first = event.first
        this.page = page
      } else {
        // Filter button click or initial load - reset to page 1
        page = 1
        this.page = 1
        this.currentPage = 1
        this.first = 0
      }

      // Calculate offset based on page number
      const offset = (page - 1) * this.limit

      // Build params with URLSearchParams
      const params = new URLSearchParams({
        limit: this.limit,
        offset: offset
      })

      // Add filters independently (support multiple filters)
      if (this.filters.item_code) {
        params.append('item_code', this.filters.item_code)
      }
      if (this.filters.item_name) {
        params.append('item_name', this.filters.item_name)
      }
      if (this.filters.category) {
        params.append('category', this.filters.category)
      }
      if (this.supplier_selected && this.supplier_selected.code) {
        params.append('supplier', this.supplier_selected.code)
      }

      const url = `${
        process.env.VUE_APP_API_URL
      }/warehouse/items-stock?${params.toString()}`

      try {
        const response = await this.$http.get(url)
        this.loading.main = false

        if (response.status === 200) {
          this.items = response.data.data.warehouse_items_stock || []
          this.total = response.data.data.total || 0
          this.first = (page - 1) * this.limit
        } else {
          console.error('Failed to get data')
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        this.loading.main = false
        console.error('Error fetching stock items:', error)
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
      }
    },

    /**
     * Handle pagination event
     * @param {Object} event - Pagination event from DataTable
     */
    onPage(event) {
      this.getListStockItemsWarehouse(event)
    },

    /**
     * Reset all filters and reload data
     */
    async resetFilters() {
      this.filters.item_code = ''
      this.filters.item_name = ''
      this.filters.category = ''
      this.supplier_selected = null
      this.page = 1
      this.currentPage = 1
      this.first = 0

      // Reload suppliers for fresh dropdown data
      await this.loadSuppliersForDropdown()

      // Reset to page 1 and reload
      this.getListStockItemsWarehouse()
    },

    // Debounce utility method
    debounce(fn, delay) {
      let timeout
      return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
      }
    },

    // API-based supplier loading with limit
    async getSuppliers(searchQuery = '', limit = 20) {
      this.loading.suppliers = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/suppliers`,
          {
            params: {
              search: searchQuery,
              limit: limit
            }
          }
        )

        if (response.status === 200) {
          return response.data.data.suppliers.map(item => {
            return {
              displayName: `${item.code} - ${item.name}`,
              alias: `${item.code} - ${item.name}`,
              code: item.code,
              id: item.id,
              name: item.name,
              parent: item.parent
            }
          })
        }
        return []
      } catch (error) {
        console.error('Error fetching suppliers:', error)
        this.showToast('error', 'Error', 'Failed to fetch suppliers')
        return []
      } finally {
        this.loading.suppliers = false
      }
    },

    // Load initial suppliers for dropdown (first load when dropdown clicked)
    async loadSuppliersForDropdown() {
      const suppliers = await this.getSuppliers('', 20)
      this.autoFilteredValue = suppliers
    },

    // Actual search method that performs API call (called by debounced wrapper)
    async _searchSuppliers(event) {
      const query = event.query || ''

      // If empty query (dropdown clicked), always load initial suppliers
      if (!query) {
        await this.loadSuppliersForDropdown()
        return
      }

      // API call with search query
      const suppliers = await this.getSuppliers(query, 20)
      this.autoFilteredValue = suppliers
    },

    // Initialize debounced search function
    initDebouncedSearch() {
      if (!this.$_searchSuppliersDebounced) {
        this.$_searchSuppliersDebounced = this.debounce(
          this._searchSuppliers,
          500
        )
      }
    },

    // Wrapper that calls debounced version
    searchSupplier(event) {
      const query = event.query || ''

      // If empty query (dropdown clicked), execute immediately without debounce
      if (!query) {
        this._searchSuppliers(event)
        return
      }

      // For typing/search, use debounce to reduce API calls
      if (!this.$_searchSuppliersDebounced) {
        this.initDebouncedSearch()
      }
      this.$_searchSuppliersDebounced(event)
    },

    /**
     * Show toast notification
     * @param {string} severity - 'success', 'error', 'warn', 'info'
     * @param {string} summary - Toast title
     * @param {string} detail - Toast message
     */
    showToast(severity, summary, detail) {
      this.$toast.add({
        severity: severity,
        summary: summary,
        detail: detail,
        life: 3000
      })
    },

    /**
     * Truncate text to specified length and add ellipsis
     * @param {string} text - Text to truncate
     * @param {number} maxLength - Maximum length before truncation
     * @returns {string} Truncated text with ellipsis
     */
    truncateText(text, maxLength) {
      if (!text) return '-'
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #2d3748;
}

.filter-section {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.block {
  display: block;
}

.mb-1 {
  margin-bottom: 0.5rem;
}

.w-100 {
  width: 100%;
}

.warehouse-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
}

.warehouse-text {
  font-size: 0.9rem;
  color: #2d3748;
}

/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

:deep(.p-datatable.p-datatable-sm) {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
    padding: 0.75rem;
    white-space: nowrap;
    box-sizing: border-box;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
    padding: 0.75rem;
    white-space: nowrap;
    box-sizing: border-box;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }

  // Ensure header and body cells align properly
  .p-datatable-scrollable-header-table,
  .p-datatable-scrollable-body-table {
    table-layout: fixed;
    width: 100%;
  }

  .p-datatable-scrollable-header-table {
    width: 100%;
  }

  .p-datatable-scrollable-body-table {
    width: 100%;
  }
}

/* Responsive */
@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }

  .filter-section {
    padding: 1rem;
  }
}
</style>
